module.exports = __webpack_public_path__ + "img/logo.e90def3b.png";